import { DataTable, Heading, Loader } from "@/components";
import useFiscalYearLifecycle from "./useFiscalYearLifecycle";

const FiscalYearLifeCycle = () => {
  const {currentFinanceYear, columns, communityData, breadcrumbData, data, isLifeCycleLoading} = useFiscalYearLifecycle();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title={`Fiscal Year Lifecycle - ${communityData?.communityName || communityData?.name || ""}`}
            breadcrumbData={breadcrumbData}
          />
    
        </div>
        <div>
          <span className="text-[26px] font-semibold text-primary">{currentFinanceYear}</span>
        </div>
      </div>

      {/* Responsive Table */}
      {isLifeCycleLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={data}
        />
      )}
    </div>
  )
}

export default FiscalYearLifeCycle;
